import { KEYS } from '../../../../../../l18n/constants';
import { useL18nContext } from '../../../../ContextProvider/L18n';
import computeClassName from '../../../../../../utils/computeClassName';
import handleClick from '../../../../../../utils/handleClick';

const constants = Object.freeze({
  CLASSNAME_BASE: 'inline-block sm:hidden appearance-none uppercase text-cc-body-medium text-cc-primary-contrast cursor-pointer',
});

const propsDefaults = Object.freeze({
  isToggleOn: false,
  toggleFn: null,
});

export default function MobileMenuToggle(
  {
    isToggleOn = propsDefaults.isToggleOn,
    toggleFn = propsDefaults.toggleFn,
    className = ''
  }
) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const translatedTitleLabel = getTranslationFor(isToggleOn?KEYS.L18N_KEY_LABEL_CLOSE:KEYS.L18N_KEY_LABEL_MENU);
  const toggleOnClick = handleClick(toggleFn);
  return (
    <button className={computedClassName} onClick={toggleOnClick} title={translatedTitleLabel}>
      <span className="flex flex-row items-center">
        <span className="flex flex-col items-start justify-center w-10 group relative">
          <span className="relative block bg-cc-primary-contrast rounded-full w-full h-1.25 my-1"/>
          <span className="relative block bg-cc-primary-contrast rounded-full w-3/4 group-hover:w-full h-1.25 my-1 transition-cc-size duration-150 ease-linear"/>
          <span className="relative block bg-cc-primary-contrast rounded-full w-1/2 group-hover:w-full h-1.25 my-1 transition-cc-size duration-150 ease-linear"/>
        </span>
        <span className="ml-5 hidden xs:inline-block">{translatedTitleLabel}</span>
      </span>
    </button>
  );
}
